import {historyFactory} from './routerContext';
import store from './store';

export default historyFactory(store);